import { render, staticRenderFns } from "./CouponCard.vue?vue&type=template&id=c312ec04&scoped=true&"
import script from "./CouponCard.vue?vue&type=script&lang=js&"
export * from "./CouponCard.vue?vue&type=script&lang=js&"
import style0 from "./CouponCard.vue?vue&type=style&index=0&id=c312ec04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c312ec04",
  null
  
)

export default component.exports